const SendIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#041e39" />
          <stop offset="1" stopColor="#57687a" />
        </linearGradient>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_3750"
            data-name="Rectangle 3750"
            width="16"
            height="16"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g id="Group_44778" data-name="Group 44778" transform="translate(2322 -12837)">
        <rect
          id="Rectangle_3748"
          data-name="Rectangle 3748"
          width="24"
          height="24"
          rx="12"
          transform="translate(-2322 12837)"
          fill="url(#linear-gradient)"
        />
        <g id="Mask_Group_14" data-name="Mask Group 14" transform="translate(-2318 12841)">
          <g id="send_1_" data-name="send (1)" transform="translate(-0.11 6.992) rotate(-50)">
            <g id="Group_43694" data-name="Group 43694" transform="translate(0 0)">
              <path
                id="Path_24355"
                data-name="Path 24355"
                d="M13.719,6.123a1.452,1.452,0,0,0-.674-.674L2.086.146A1.452,1.452,0,0,0,.1,1.993L2.01,6.756.1,11.52a1.453,1.453,0,0,0,1.982,1.848l10.959-5.3A1.453,1.453,0,0,0,13.719,6.123ZM1.664,12.495A.484.484,0,0,1,1,11.879L2.859,7.24h9.665ZM2.859,6.272,1,1.633a.472.472,0,0,1,.12-.533.469.469,0,0,1,.541-.082L12.523,6.272H2.859Z"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default SendIcon;
